enum Weather {
    SUNNY = "sunny",
    RAINY = "rainy",
    PARTLY_RAINY = "partly_rainy",
    WINDY = "windy",
    FOGGY = "foggy",
    STORMY = "stormy",
    CLOUDY = "cloudy",
    PARTLY_CLOUDY = "partly_cloudy",
    THUNDERSTORM = "tunderstorm"
}


export { Weather }